<template>
  <div ref="containerRef" :class="[$style.container, isStatic && $style.static]">
    <h2 :class="$style.head">
      {{ head }}
    </h2>
    <div
      ref="textRef"
      :class="[
        $style.text,
        !isInnerContainerSmaller && $style.shadow,
        isContainerFullWidth && $style.hideShadow,
      ]"
    >
      <div
        ref="overflowRef"
        :class="$style.textOverflow"
        :style="
          isContainerFullWidth || initialTeaserTextHeight === 0
            ? ''
            : `overflow: hidden; height:${initialTeaserTextHeight}px`
        "
      >
        <div ref="textInnerRef">
          {{ text }}
        </div>
        <div
          v-if="!isInnerContainerSmaller || isContainerFullWidth"
          :class="$style.more"
          @click="setContainerFullWidth"
        >
          <div>
            <span v-text="isContainerFullWidth ? ' weniger' : 'mehr'" />
            <i v-if="isContainerFullWidth" class="fas fa-chevron-up" />
            <i v-else class="fas fa-chevron-down" />
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.docLinkContainer">
      <!-- TODO: remove classes "Button__white Button__button" when using the component from Vue -->
      <div v-if="hasButtons" :class="[$style.buttonsContainer, 'Button__white Button__button']">
        <Button1XP
          v-for="(buttonLink, buttonIndex) in buttonLinks"
          :key="buttonIndex"
          size="s"
          :target="buttonLink.newWindow ? '_blank' : '_self'"
          :text="buttonLink.text"
          :url="buttonLink.url"
          :variant="buttonLink.variant"
        />
      </div>
      <a v-for="(link, index) in links" :key="index" :class="$style.docLink" href="#"
        >{{ link }}
      </a>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, onUpdated, ref } from 'vue';
import { checkIsMobile } from '../../utils/media';
import Button1XP from '../Button1XP/Button1XP.vue';

defineProps({
  head: String,
  text: String,
  hasButtons: {
    type: Boolean,
    default: false,
  },
  buttonLinks: {
    type: Array,
    default: () => [],
  },
  links: {
    type: Array,
    default: () => [],
  },
  isStatic: Boolean,
});

const isMobile = ref(false);
const isInnerContainerSmaller = ref(true);
const isContainerFullWidth = ref(false);
const tout = ref(null);
const containerRef = ref(null);
const textRef = ref(null);
const overflowRef = ref(null);
const textInnerRef = ref(null);
const initialTeaserTextHeight = ref(0);
const expandedTeaserTextHeight = ref(0);
let resizeObserver = null;

const checkScreenSize = () => (isMobile.value = checkIsMobile());

const getOverflowHeight = () => {
  const lineHeight = 22; // line-height as defined in stylesheet
  const lines = parseInt(textRef.value?.offsetHeight / lineHeight);
  const height = lines * lineHeight;
  return height;
};

const resizeHandler = () => {
  clearTimeout(tout);
  initialTeaserTextHeight.value = 0;

  tout.value = setTimeout(() => {
    checkScreenSize();
    setOverflowElements();
    if (isContainerFullWidth.value) {
      setContainerSize();
    }
    initialTeaserTextHeight.value = getOverflowHeight();
  }, 100);
};

const setOverflowElements = () => {
  if (textRef.value && textInnerRef.value) {
    isInnerContainerSmaller.value = textInnerRef.value.clientHeight < textRef.value.clientHeight;
  }
};
const findColumnsElement = () => {
  let $containerParent = containerRef.value.parentElement;

  for (let i = 0; i < 5; i++) {
    if ($containerParent.className.indexOf('columns') >= 0) {
      return $containerParent;
    } else {
      return ($containerParent = $containerParent.parentElement);
    }
  }
  return null;
};

const setContainerFullWidth = () => {
  isContainerFullWidth.value = !isContainerFullWidth.value;
  setContainerSize();
};

const setContainerSize = () => {
  const columnsContainer = findColumnsElement();

  if (columnsContainer && isContainerFullWidth.value) {
    if (
      textRef.value &&
      textInnerRef.value &&
      textInnerRef.value.clientHeight > textRef.value.clientHeight
    ) {
      textRef.value.style.maxHeight = 'none';
      containerRef.value.style.height = `${
        expandedTeaserTextHeight.value +
        (containerRef.value.clientHeight - textRef.value.clientHeight + (isMobile.value ? 76 : 56))
      }px`;
      // 56 = moreLink + spacings
    }
  } else {
    containerRef.value.style.width = null;
    containerRef.value.style.height = null;
    textRef.value.style.maxHeight = null;
  }
};

onMounted(() => {
  window.addEventListener('resize', resizeHandler, false);
  checkScreenSize();
  setOverflowElements();
  initialTeaserTextHeight.value = getOverflowHeight();

  expandedTeaserTextHeight.value = textInnerRef.value?.offsetHeight;
});

onUpdated(() => {
  if (tout.value === null) {
    resizeHandler();
  }
});

onUnmounted(() => {
  window.removeEventListener('resize', resizeHandler, false);
  if (resizeObserver) {
    resizeObserver.disconnect();
  }
});
</script>

<style module lang="scss">
@forward './TextTeaser.scss';
</style>
